module.exports = __webpack_public_path__ + "cf627f690a270667c3d5f761a239f062.png";